import { createLogger } from 'redux-logger';

import { Middleware } from 'types';

const createReduxMiddleware = (platformMiddleware: Middleware): Middleware => {
  const middleware = [...platformMiddleware];

  if (process.env.NODE_ENV !== 'production' && process.browser) {
    const logger = createLogger({ collapsed: true });
    middleware.push(logger);
  }

  return middleware;
};

export default createReduxMiddleware;
